import axios from 'axios';
import config from '../common/config';

const MAX_ERRORS_PER_SESSION = 10;
const reportedUrls = new Set();

export async function logImageError({ page, imageUrl, apptoken }) {
  if (!imageUrl || !imageUrl.includes('firebasestorage.googleapis.com')) return;
  if (reportedUrls.size >= MAX_ERRORS_PER_SESSION) return;
  if (reportedUrls.has(imageUrl)) return;

  reportedUrls.add(imageUrl);

  let errorMessage = 'unknown';
  try {
    const response = await fetch(imageUrl);
    errorMessage = `http_${response.status}`;
  } catch (e) {
    errorMessage = e.message || 'network_error';
  }

  const formData = new FormData();
  formData.append('data', JSON.stringify({ page, image_url: imageUrl, apptoken: apptoken || '', error_message: errorMessage }));

  axios.post(`${config.config.ROOT_URL}/log_image_error`, formData).catch(() => {});
}
